import { createBrowserRouter } from "react-router-dom";
import AuthenticationRoomCall from "./components/AuthenticationRoomCall";
import HomePage from "./pages/home/Home";
export const router = createBrowserRouter([
    {
      path: "/roomcall",
      element: <AuthenticationRoomCall/>,
    },
    {
      path: "/",
      element: <HomePage/>,
    }
]);
  